
// ********* Import CSS ******************** //

import "./user-popup.css";

// **************** Modal ******************** //

class UserPopup extends HTMLElement {
  connectedCallback() {

    this.innerHTML = `

      <div id="user-popup" class="popup">
        
        <div class="popup-content">

          <div class="popup-container">

            <div class="close">
              <button id="popup-close"><span class="popup-close">X</span></button>
            </div>

            <div class="popup-logo">
              <h1 class="foiled-logo-popup foiled-font">foiled.<span class="pretty-logo-popup pretty-font">Pretty</h1>
            </div>

            <p id="popup-title"></p>

            <p id="popup-main-text"></p>

            <p id="popup-sub-text"></p>

          </div>
        
        </div>
        
      </div> 
    `
  }
}

customElements.define('user-popup', UserPopup);